export default __webpack_public_path__ + "static/media/TeethOrange.f9e302f7.svg";